import { render } from "./TestimonialItem.vue?vue&type=template&id=46c9837b&scoped=true"
import script from "./TestimonialItem.vue?vue&type=script&lang=js"
export * from "./TestimonialItem.vue?vue&type=script&lang=js"

import "./TestimonialItem.vue?vue&type=style&index=0&id=46c9837b&lang=postcss&scoped=true"

import exportComponent from "/github/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-46c9837b"]])

export default __exports__